import { ProgressBarBand } from "@app/shared";
import { Component } from "react";

interface AccuracyTooltipLegendProps {
  inspectionName: string;
  progressBarBands: ProgressBarBand[];
}

export default class AccuracyTooltipLegend extends Component<AccuracyTooltipLegendProps> {
  public render() {
    return (
      <div className="accuracy-tooltip-legend">
        <div>
          {this.props.inspectionName}
        </div>
        <hr />
        <table className="table table-borderless">
          <tbody>
            {this.props.progressBarBands.map((a, index) => {
              return (
                <tr className="text-white" key={index}>
                  <td className="px-1 py-0">
                    <i className="fa fa-circle" style={{ color: a.color }} />
                  </td>
                  <td className="px-1 py-0 text-right">
                    {a.outOfScale ? "<0.1" : a.percent.toFixed(1)}%
                  </td>
                  <td className="px-1 py-0">
                    {a.tooltip}
                  </td>
                  {this.props.progressBarBands.some(band => band.justification) &&
                    <td className="px-1 py-0">
                    {a.justification && a.justification}
                    </td>
                  }                  
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
